import { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { ExamServices } from 'Services/examServices';

interface IUpdatePaymentModal {
  show: boolean;
  onHide: () => void;
  mapping: string;
  reloadData: () => void;
}

export default function UpdatePaymentModal({ show, onHide, mapping, reloadData }: IUpdatePaymentModal) {
  const [isFeePaid, setIsFeePaid] = useState<boolean>(false);
  const [transactionId, setTransactionId] = useState<string>('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit() {
    setSaving(true);
    try {
      const res = await ExamServices.updatePaymentDetails(mapping, {
        isFeePaid,
        transactionId: transactionId.trim() || undefined,
      });
      if (res.status === 200) {
        toast.success('Payment details updated');
        reloadData();
        onHide();
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Something went wrong');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Payment Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="fee-paid-switch"
              label={isFeePaid ? 'Fee Paid ✓' : 'Fee Not Paid'}
              checked={isFeePaid}
              onChange={(e) => setIsFeePaid(e.target.checked)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Transaction ID <span className="text-muted">(optional)</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={saving}>
          {saving ? <Spinner size="sm" animation="border" /> : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
